<button *ngIf="options.closeButton" (click)="close()" class="toast-close-button" aria-label="Close">
  <span aria-hidden="true">&times;</span>
</button>
<button
  mat-raised-button
  *ngIf="params?.details"
  (click)="showError()"
  class="close-button"
  color="warn"
  aria-label="Details"
>
  Details
</button>

<div *ngIf="title" [class]="options.titleClass" [attr.aria-label]="title">
  {{ title }}
</div>
<div
  *ngIf="message && options.enableHtml"
  role="alertdialog"
  aria-live="polite"
  [class]="options.messageClass"
  [innerHTML]="message"
></div>
<div
  *ngIf="message && !options.enableHtml"
  role="alertdialog"
  aria-live="polite"
  [class]="options.messageClass"
  [attr.aria-label]="message"
>
  {{ message }}
</div>
<div *ngIf="options.progressBar">
  <div class="toast-progress" [style.width]="width + '%'"></div>
</div>
